import LoyaltyCreditList from './LoyaltyCreditList';
import LoyaltyCreditShow from './LoyaltyCreditShow';

export default {
	list: LoyaltyCreditList,
	show: LoyaltyCreditShow,
};
